import { c as _c } from "react/compiler-runtime";
import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import { useMemo } from 'react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { useTranslation } from '@/hooks/use-translation';
import { cn } from '@/lib/utils';

/**
 * Picks the light workshop, the dark one, or whichever the system asks for.
 *
 * Three choices rather than a straight flip: "system" is the default, and a
 * binary toggle would quietly take it away the first time someone pressed it.
 */
export const ThemeToggle = t0 => {
  const $ = _c(34);
  const {
    className
  } = t0;
  const {
    t
  } = useTranslation();
  const {
    setTheme,
    theme
  } = useTheme();
  let t1;
  if ($[0] !== t) {
    t1 = t("Light", {
      ns: "navigation"
    });
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      icon: Sun,
      label: t1,
      value: "light"
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("Dark", {
      ns: "navigation"
    });
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      icon: Moon,
      label: t3,
      value: "dark"
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("System", {
      ns: "navigation"
    });
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = {
      icon: Monitor,
      label: t5,
      value: "system"
    };
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t4 || $[14] !== t6) {
    t7 = [t2, t4, t6];
    $[12] = t2;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const options = t7;
  let t8;
  if ($[16] !== className) {
    t8 = cn("size-9 text-muted-foreground", className);
    $[16] = className;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("Theme", {
      ns: "navigation"
    });
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Sun className="size-[17px] dark:hidden" />;
    t11 = <Moon className="hidden size-[17px] dark:block" />;
    $[20] = t10;
    $[21] = t11;
  } else {
    t10 = $[20];
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t8 || $[23] !== t9) {
    t12 = <DropdownMenuTrigger asChild={true}><Button variant="ghost" size="icon-sm" className={t8} aria-label={t9}>{t10}{t11}</Button></DropdownMenuTrigger>;
    $[22] = t8;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== options) {
    t13 = options.map(_temp);
    $[25] = options;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== setTheme || $[28] !== t13 || $[29] !== theme) {
    t14 = <DropdownMenuContent align="end"><DropdownMenuRadioGroup value={theme} onValueChange={setTheme}>{t13}</DropdownMenuRadioGroup></DropdownMenuContent>;
    $[27] = setTheme;
    $[28] = t13;
    $[29] = theme;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t12 || $[32] !== t14) {
    t15 = <DropdownMenu>{t12}{t14}</DropdownMenu>;
    $[31] = t12;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};
function _temp(option) {
  return <DropdownMenuRadioItem key={option.value} value={option.value}><option.icon className="size-4" />{option.label}</DropdownMenuRadioItem>;
}